import { render, staticRenderFns } from "./Microsoft.vue?vue&type=template&id=543aecdc&"
import script from "./Microsoft.vue?vue&type=script&setup=true&lang=js&"
export * from "./Microsoft.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('543aecdc')) {
      api.createRecord('543aecdc', component.options)
    } else {
      api.reload('543aecdc', component.options)
    }
    module.hot.accept("./Microsoft.vue?vue&type=template&id=543aecdc&", function () {
      api.rerender('543aecdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/channels/emailChannels/Microsoft.vue"
export default component.exports